/** Shared font-size tokens for ingestion form titles and section headings. */
export type FormFontSize = "small" | "medium" | "large";

export const DEFAULT_FORM_FONT_SIZE: FormFontSize = "medium";

/** Default section heading color; matches ingestion form `.section-heading` CSS. */
export const DEFAULT_SECTION_HEADING_COLOR = "#0066cc";

/** Default form title color; matches ingestion form `.form-title` CSS. */
export const DEFAULT_FORM_TITLE_COLOR = "#0066cc";

export const FORM_FONT_SIZE_OPTIONS: ReadonlyArray<{ value: FormFontSize; label: string }> = [
    { value: "small", label: "Small" },
    { value: "medium", label: "Medium" },
    { value: "large", label: "Large" },
];

export function normalizeFormFontSize(raw: unknown): FormFontSize {
    if (raw === "small" || raw === "large") {
        return raw;
    }
    return DEFAULT_FORM_FONT_SIZE;
}

export function sectionHeadingSizeClass(fontSize: FormFontSize | undefined): string {
    return `section-heading--${fontSize ?? DEFAULT_FORM_FONT_SIZE}`;
}

/** Reserved for form-level title styling (Phase B). */
export function formTitleSizeClass(fontSize: FormFontSize | undefined): string {
    return `form-title--${fontSize ?? DEFAULT_FORM_FONT_SIZE}`;
}
